export default {"src":"/_next/static/media/external-link.855f720e.svg","height":34,"width":34};